import classNames from 'classnames/bind';
import React, { useEffect, useMemo, useState } from 'react';
import { RiToolsLine, RiTreasureMapLine, RiPlayFill, RiNotification3Line } from 'react-icons/ri';
import { useSelector } from 'react-redux';

import Setup from './01_Setup';
import Operation from './02_Operation';
import Mission from './03_Mission';
import Notifications from './98_Notifications';
import MapTool from './99_MapTool';
import styles from './index.module.scss';

import Bar from '@/components/ui/Bar';
import SlidingPanel from '@/components/ui/SlidingPanel';
import EventEmitter from '@/libs/EventEmitter';

const cx = classNames.bind(styles);

const Sidebar = () => {
  const robots = useSelector((state) => state.robots);
  const targetRobotIds = useSelector((state) => state.robot.targetRobotIds);
  const [activeTabIndex, setActiveTabIndex] = useState();
  const [isShowNotifications, setShowNotifications] = useState(false);
  const [hasUnread, setUnread] = useState(false);

  // 각 버튼 클릭 가능여부
  const isAvailable = useMemo(() => {
    const modelIds = robots.filter(({ id }) => targetRobotIds.includes(id)).map(({ model }) => model.id);

    return {
      setup: [...new Set(modelIds)].length === 1,
      operation: [...new Set(modelIds)].length === 1,
      mission: targetRobotIds.length === 1,
    };
  }, [targetRobotIds]);

  useEffect(() => {
    const token = EventEmitter.subscribe('notifications/add', () => {
      if (!isShowNotifications) {
        setUnread(true);
      }
    });

    return () => {
      EventEmitter.unsubscribe(token);
    };
  }, [isShowNotifications]);

  useEffect(() => {
    if (isAvailable.operation) {
      setActiveTabIndex(1);
    } else {
      setActiveTabIndex();
    }
  }, [isAvailable.operation]);

  const toggle = (e) => {
    const nextActiveTabIndex = Number(e.currentTarget.dataset.index);

    if (activeTabIndex === nextActiveTabIndex) {
      setActiveTabIndex();
    } else {
      setActiveTabIndex(nextActiveTabIndex);
    }
  };

  const toggleNotifications = () => {
    if (!isShowNotifications) {
      setUnread(false);
    }
    setShowNotifications(!isShowNotifications);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('groups')}>
        <Bar size={24} horizontal />
        <div className={cx('group')}>
          <div
            data-index="0"
            className={cx(['button', { unavailable: !isAvailable.setup, active: activeTabIndex === 0 }])}
            onClick={toggle}>
            <RiToolsLine size={22} color={isAvailable.setup ? 'white' : 'gray'} />
          </div>
          <div
            data-index="1"
            className={cx([
              'button',
              'operation',
              { unavailable: !isAvailable.operation, active: activeTabIndex === 1 },
            ])}
            onClick={toggle}>
            <RiPlayFill size={26} color={isAvailable.operation ? 'white' : 'gray'} />
          </div>
          <div
            data-index="2"
            className={cx(['button', 'mission', { unavailable: !isAvailable.mission, active: activeTabIndex === 2 }])}
            onClick={toggle}>
            <RiTreasureMapLine size={20} color={isAvailable.mission ? 'white' : 'gray'} />
          </div>
        </div>
      </div>
      <div className={cx('groups')}>
        <div className={cx('group')}>
          <div
            className={cx(['button', { active: isShowNotifications, dot: hasUnread }])}
            onClick={toggleNotifications}>
            <RiNotification3Line size={20} color="white" />
          </div>
        </div>
        <Bar size={24} horizontal />
        <MapTool />
        <Bar size={24} horizontal />
      </div>

      {/* Panels */}
      <SlidingPanel active={activeTabIndex === 0} origin="left">
        <Setup />
      </SlidingPanel>
      <SlidingPanel active={activeTabIndex === 1} origin="left">
        <Operation />
      </SlidingPanel>
      <SlidingPanel active={activeTabIndex === 2} origin="left">
        <Mission />
      </SlidingPanel>
      <SlidingPanel active={isShowNotifications} origin="bottom" style={{ right: 48 }}>
        <Notifications />
      </SlidingPanel>
    </div>
  );
};

export default Sidebar;
